import { useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export function useFeedbacks() {
  const { data, fetchMore, loading } = useQuery(AdminAPI.simpleFeedback.QUERY, {
    variables: {
      page: 0,
      pageSize: 25,
      filter: {},
      withStay: true,
      withSpace: true
    }
  })

  const canLoadMore = useMemo(() => {
    if (!data) return false

    const totalPages = data.querySimpleFeedbacks.metadata.totalPages
    const currentPage = data.querySimpleFeedbacks.metadata.pageNumber

    return totalPages > currentPage
  }, [data])

  const loadMore = useCallback(() => {
    if (!data || !canLoadMore) return

    fetchMore({
      variables: {
        page: data.querySimpleFeedbacks.metadata.pageNumber + 1
      },
      updateQuery(previousQueryResult, { fetchMoreResult }) {
        if (!fetchMoreResult) return previousQueryResult

        return {
          querySimpleFeedbacks: {
            items: [
              ...previousQueryResult.querySimpleFeedbacks.items,
              ...fetchMoreResult.querySimpleFeedbacks.items
            ],
            metadata: fetchMoreResult.querySimpleFeedbacks.metadata
          }
        }
      }
    })
  }, [canLoadMore, data, fetchMore])

  const items = useMemo(() => {
    if (!data) return []

    return data.querySimpleFeedbacks.items.map(item =>
      getFragment(SharedAPI.simpleFeedback.SIMPLE_FEEDBACK_FRAGMENT, item)
    )
  }, [data])

  return {
    items,
    loadMore,
    loading,
    canLoadMore
  }
}
